import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import ICompanyCreateRequestBody from 'services/httpClient/requests/company/ICompanyCreateRequestBody';

import { companyActions } from '../index';
import { ICompanyCreateRequestAction } from '../reducers/create/request';

function* create(action: PayloadAction<ICompanyCreateRequestAction>) {
  try {
    const body: ICompanyCreateRequestBody = {
      vat_number: action.payload.data.VAT,
      companyName: action.payload.data.companyName,
      email: action.payload.data.email,
      first_name: action.payload.data.firstName,
      phone: action.payload.data.gsm,
      name: `${action.payload.data.firstName} ${action.payload.data.lastName}`,
      address: {
        city: action.payload.data.headQuarters.city,
        number: action.payload.data.headQuarters.number,
        street: action.payload.data.headQuarters.street,
        postcode: action.payload.data.headQuarters.zip,
      },
      last_name: action.payload.data.lastName,
      locale: action.payload.data.locale,
      website: action.payload.data.website,
      mission_language: action.payload.data.language,
      iban: action.payload.data.iban,
    };

    yield call(
      httpClient.post,
      '/backoffice/v1/intervention_partnerships/create_without_trader',
      body,
    );

    yield put(companyActions.createSuccess());

    action.payload.functions.goBack();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(companyActions.createFailure());
  }
}

export default create;
